import { render, staticRenderFns } from "./live-watching.vue?vue&type=template&id=e8bf8d6a&"
import script from "./live-watching.vue?vue&type=script&lang=js&"
export * from "./live-watching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports